import "./index.css";
import 'dayjs/locale/de';

/*import "@mantine/core/styles.css";
import '@mantine/dates/styles.css';*/
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "~/App";
import { appRoutes } from "~/constants/appRoutes.ts";

import initI18n from "./i18n/setup";

initI18n({ debug: false });

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<BrowserRouter basename={appRoutes.base().path}>
			<App />
		</BrowserRouter>
	</React.StrictMode>,
);
